import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <span className="footer__mark">IV</span>
          <div>
            <strong>INIVAYAL</strong>
            <p>Agritech Private Limited</p>
          </div>
        </div>

        <nav className="footer__links">
          <a href="#home">Home</a>
          <a href="#gallery">Gallery</a>
          <a href="#pitch-deck">Pitch Deck</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>

        <p className="footer__tagline">Learn. Grow. Sustain.</p>
      </div>
      <div className="container footer__bottom">
        <span>&copy; {new Date().getFullYear()} Inivayal Agritech Pvt. Ltd. All rights reserved.</span>
        <span>Madurai, Tamil Nadu, India</span>
        <span className="footer__credit">
          Website by{' '}
          <a href="https://jeevamatrix.vercel.app/" target="_blank" rel="noreferrer">
            Jeeva Matrix
          </a>
        </span>
      </div>
    </footer>
  );
}